export const STATUT_LABELS = {
  a_traiter: 'À traiter',
  urgent: 'Urgent',
  devis_a_generer: 'Devis à générer',
  traite: 'À valider',
  a_rappeler: 'À relancer',
  sans_suite: 'Sans suite',
  devis_a_envoyer: 'Devis à envoyer',
  devis_envoye: 'Devis envoyé',
  contract_envoye: 'Contrat envoyé',
  convocation_envoye: 'Convocation envoyée',
  feuillepresence_envoye: 'Feuille de présence envoyée',
  rappel_envoye: 'Relancé',
  devis_accepte: 'Devis accepté par le client',
  devis_refuse: 'Devis refusé par le client',
  contrat_signe: 'Contrat signé par le client',
  termine: 'Terminé',
  deja_conclu: 'Déjà conclu',
};

export const STATUT_DEVIS_LABELS = {
  brouillon: 'Brouillon',
  a_valider: 'À valider',
  valide: 'Validé',
  envoye: 'Envoyé',
  relance: 'Relancé',
  accepte: 'Accepté',
  deja_conclu: 'Déjà conclu',
  refuse: 'Refusé',
  erreur_ia: 'Erreur IA',
};

/** Montants : le backend renvoie des NUMERIC sous forme de chaînes. */
export function formatMontant(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return `${n.toLocaleString('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} €`;
}

export function formatDate(value) {
  if (!value) return '—';
  // 'aaaa-mm-jj' (colonne DATE) : une date sans heure, à lire telle quelle —
  // new Date('2026-09-16') vaudrait minuit UTC, soit la veille à l'ouest de
  // Greenwich.
  const jour = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value));
  const d = jour
    ? new Date(Number(jour[1]), Number(jour[2]) - 1, Number(jour[3]))
    : new Date(value);
  return d.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

/**
 * Nombre de jours entiers écoulés depuis `value` jusqu'à aujourd'hui.
 *
 * La comparaison se fait à minuit de part et d'autre, pas sur l'écart brut
 * d'horodatages : un devis parti hier à 18 h doit compter 1 jour ce matin à
 * 9 h, alors qu'un écart en heures (15 h) en donnerait 0.
 */
export function joursDepuis(value) {
  if (!value) return null;
  const debut = new Date(value);
  if (Number.isNaN(debut.getTime())) return null;

  const jour = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const MS_PAR_JOUR = 24 * 60 * 60 * 1000;
  return Math.max(0, Math.round((jour(new Date()) - jour(debut)) / MS_PAR_JOUR));
}

/** « aujourd'hui », « hier », « il y a 5 jours ». */
export function formatAnciennete(value) {
  const jours = joursDepuis(value);
  if (jours === null) return null;
  if (jours === 0) return "aujourd'hui";
  if (jours === 1) return 'hier';
  return `il y a ${jours} jours`;
}

export function formatDateTime(value) {
  if (!value) return '—';
  return new Date(value).toLocaleString('fr-FR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/**
 * Numéro de téléphone à la française : « 01 23 45 67 89 », « +33 1 23 45 67 89 ».
 * Un numéro qu'on ne sait pas découper (étranger, saisie libre) est rendu tel quel.
 */
export function formaterTelephone(valeur) {
  if (valeur === null || valeur === undefined) return '';
  const brut = String(valeur).trim();
  if (!brut) return '';
  const chiffres = brut.replace(/[\s.\-()]/g, '');
  const international = chiffres.match(/^(?:\+|00)33(0?)(\d{9})$/);
  if (international) {
    const n = international[2];
    return `+33 ${n[0]} ${n.slice(1).replace(/(\d{2})(?=\d)/g, '$1 ')}`;
  }
  if (/^0\d{9}$/.test(chiffres)) return chiffres.replace(/(\d{2})(?=\d)/g, '$1 ');
  return brut;
}
